import PropTypes from 'prop-types';
import React from 'react';
import Icon from './Icon';
import ButtonUnstyled from 'components/ButtonUnstyled';
import {injectIntl, defineMessages} from 'react-intl';

import './ModalHeaderWithClose.css';

const MESSAGES = defineMessages({
  close: {
    defaultMessage: 'Close',
    id: 'ModalHeaderWithClose__CloseLabel',
    description: 'Label for icon that closes the modal',
  },
});

const ModalHeaderWithClose = ({children, icon, onClose, intl}) => (
  <div className="ModalHeaderWithClose">
    {children}
    <ButtonUnstyled
      className="ModalHeaderWithClose__Close"
      onClick={onClose}
      title={intl.formatMessage(MESSAGES.close)}
    >
      {icon || <Icon icon={Icon.OPTIONS.X} />}
    </ButtonUnstyled>
  </div>
);

ModalHeaderWithClose.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default injectIntl(ModalHeaderWithClose);
